import './index.css';
import { __rest } from '../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { Button as Button$1 } from '@vds/core';
import styles from './button.module.scss.js';

const Button = (props) => {
    const { kind = 'primary', surface = 'lightPrimary' } = props, rest = __rest(props, ["kind", "surface"]);
    const mappedSurface = String(surface).includes('dark') ? 'dark' : 'light';
    const buttonStyles = [styles.buttonWrapper, styles[surface]];
    if (kind === 'brandHighlight' && mappedSurface !== 'dark') {
        buttonStyles.push(styles.brandHighlight);
    }
    return (jsx("div", { className: buttonStyles.join(' '), children: jsx(Button$1, Object.assign({ surface: surface }, rest, { kind: kind === 'brandHighlight' ? 'primary' : kind })) }));
};

export { Button as default };
